import { Route, Routes } from 'react-router-dom';
import DashboardContent from './Dashboard';
import LoginPage from './pages/LoginPage/LoginPage';
import MailBox from './pages/MailBox/MailBox';
import ExpertInfo from './pages/expertInfo/ExpertInfo';

export default (props) => {
  return (
    <Routes>
      <Route index element={<LoginPage {...props} />} />
      <Route path='dashboard' element={<DashboardContent {...props} />} />
      <Route path='expert-info' element={<ExpertInfo {...props} />} />
      <Route path='mail-box/*' element={<MailBox {...props} />} />
    </Routes>
  );
};
